var map = {
	"./BG24_logo_blue.png": 1598,
	"./BG24_logo_blue.png.license": 1752,
	"./BG24_logo_green.png": 8797,
	"./BG24_logo_green.png.license": 8633,
	"./BG24_logo_red.png": 5261,
	"./BG24_logo_red.png.license": 8197,
	"./BG24_logo_yellow.png": 2254,
	"./BG24_logo_yellow.png.license": 6108,
	"./abstract_data": 1112,
	"./abstract_data.json": 1112,
	"./abstract_data.json.license": 4230,
	"./bg24-banner.png": 7444,
	"./bg24-banner.png.license": 7016,
	"./bga24.png": 7222,
	"./bga24.png.license": 6914,
	"./logo.png": 3153,
	"./logo.png.license": 495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;